import React from 'react';
import PropTypes from 'prop-types';
import ConstructionCard from './ConstructionCard';
import PresentationCard from './PresentationCard';

const DashboardCard = props => {
  const { constructionCardProps, emptyComponent, getItemCardProps, items, title, type } = props;

  const renderItems = () => {
    if (!items.length) {
      return (
        <div className={`empty-dashboard-card empty-${type}-card`}>
          {emptyComponent}
        </div>
      );
    }

    return items.map(item => (
      <PresentationCard
        key={item.id}
        type="mini"
        titleSize={14}
        styleConfig={{ corner: 'xsmall' }}
        {...getItemCardProps(item)}
      />
    ));
  }

  return (
    <div className={`card-fader-container dashboard-card-fader ${type}-fader`}>
      <ConstructionCard 
        size="narrow" 
        title={title} 
        titleSize={18} 
        alwaysExpanded={true} 
        className={`dashboard-card ${type}-card`}
        {...constructionCardProps}
      >
        {renderItems()}
      </ConstructionCard>
    </div>
  );
}

DashboardCard.propTypes = {
  constructionCardProps: PropTypes.object,
  emptyComponent: PropTypes.elementType,
  getItemCardProps: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  type: PropTypes.string
};

DashboardCard.defaultProps = {
  items: []
};

export default DashboardCard;
